import * as React from 'react'

import { Card, PrimaryButton, Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../messages'

interface NotConnectedViewProps {
  onConnect: () => void
}

export const NotConnectedView = ({ onConnect }: NotConnectedViewProps) => {
  const intl = useProcurifyIntl()

  return (
    <Card>
      <Card.Content>
        <Space align='center'>
          <Text>{intl.formatMessage(messages.notConnectedDescription)}</Text>
          <PrimaryButton onClick={onConnect}>
            {intl.formatMessage(messages.addToSlackButton)}
          </PrimaryButton>
        </Space>
      </Card.Content>
    </Card>
  )
}
